<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Project Parts List</span>
      <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="ttmodal__body">
    <div style="margin-left: 39%;" *ngIf="loading">
      <mat-spinner> </mat-spinner>
  </div>

    <div *ngIf="!loading">
      <ng-container>
        <table class="table table--striped table--full-width"  style="font-size: small;">
  
          <thead>
              <tr>
                  <th>Observation Point</th>
                  <th>Parts</th>
              </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of ProjectPartsList">
              <tr>
                    <td class="CelltextWrap columncell" >{{item.ObsPointName}}</td>
                    <td style="width: 500px;" class="CelltextWrap columncell" >{{item.PartsList}}</td>
              </tr>
              </ng-container>
          </tbody>
        </table>
      </ng-container>
    </div> 
     
  </div>
  <div class="ttmodal__footer" *ngIf="!loading">
      <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" [class.loading]="savingChanges" (click)="ExportToExcel()"><span
              class="button__text">Export</span></a>
            
  </div>


</div>